// import { useEffect, useState } from 'react';
// import { Form, Formik } from 'formik';
// import { GoogleLogin } from '@react-oauth/google';
// import { Link, useNavigate } from 'react-router-dom';
// import BackNavigation from 'src/components/common/backNavigation/BackNavigation';
// import Button from 'src/components/button/Button';
// import Typography from 'src/components/common/typography/Typography';
// import InputField from 'src/components/common/formFields/inputField/InputField';
// import { componentSizeVariantsEnum } from 'src/constants/common.constants';
// import { EyeIcon, EyeOffIcon, MailIcon, PasswordIcon } from 'src/components/common/common.icons';
// import { resetRedirection, signIn } from 'src/store/auth/auth.slice';
// import { useAppDispatch, useAppSelector } from 'src/store/hooks';
// import useUrlParamValue from 'src/hooks/useUrlParamValue/useUrlParamValue';
// import { TSignInResponse } from 'src/services/apiEndpoint.types.ts';
// import { APIResponse } from 'src/services/base.api.service';

// import './login.scss';
// import signInValidationSchema from './login.validationSchema';

// export type TLogInFormValues = {
//   email: string;
//   password: string;
//   googleToken: string;
// };

// const Login = () => {
//   const initialValues: TLogInFormValues = {
//     email: '',
//     password: '',
//     googleToken: null
//   };

//   const [maskPassword, setMaskPassword] = useState<boolean>(true);
//   const [googleToken, setGoogleToken] = useState<string | null>(null);

//   // Hooks
//   const { paramValue } = useUrlParamValue();

//   const prevRoute = paramValue({ paramName: 'prev' });

//   const {
//     loading,
//     shouldRedirectToDashboard,
//     shouldRedirectToRoleSelection,
//     shouldRedirectToForceChangePassword
//   } = useAppSelector((store) => store.auth);
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();

//   // const handleGoogleSignIn = async (email, password, googleToken) => {
//   //   const clientId = "367t8p3stucbnbkeuqhbovchji";
//   //   const redirectUri = "http://localhost:3001"
//   //   const cognitoDomain = "https://htraction.auth.ap-south-1.amazoncognito.com";

//   //   window.location.href = `https://htraction.auth.ap-south-1.amazoncognito.com/login?client_id=367t8p3stucbnbkeuqhbovchji&response_type=token&scope=email+openid+phone&redirect_uri=http%3A%2F%2Flocalhost%3A3001%2Flogin`;

//   //   let idToken = null;
//   //   let accessToken = null;
//   //   let refreshToken = null;
//   //   const extractTokensFromUrl = async () => {
//   //     console.log("extractTokensFromUrl");
//   //     const hash = window.location.hash;
//   //     const params = new URLSearchParams(hash.replace('#', ''));
//   //     accessToken = params.get('access_token');
//   //     idToken = params.get('id_token');
//   //     refreshToken = params.get('refresh_token');
//   //     console.log("accessToken", accessToken);
//   //     console.log("idToken", idToken);
//   //     setGoogleToken(`${idToken} + , +${accessToken} + , ${refreshToken}`);

//   //     if (accessToken) {
//   //       handleSubmit({ email, password, googleToken: accessToken });
//   //     }
//   //   };
//   //   await extractTokensFromUrl();
//   // };

//   // const redirectDash= false;

//   // const extractTokensFromUrl = async () => {
//   //   console.log("extractTokensFromUrl");
//   //   const hash = window.location.hash;
//   //   const params = new URLSearchParams(hash.replace('#', ''));
//   //   const accessToken = params.get('access_token');
//   //   const idToken = params.get('id_token');
//   //   const refreshToken = params.get('refresh_token');
//   //   console.log("accessToken", accessToken);
//   //   console.log("idToken", idToken);
//   // };

//   // useEffect(() => {
//   //   extractTokensFromUrl();

//   //   if (redirectDash) {
//   //     console.log("redirectDash");
//   //     navigate('/dashboard');
//   //   }
//   //   return () => {
//   //     console.log("resetRedirection");
//   //     dispatch(resetRedirection());
//   //   };
//   // }, []);

//   const handleSubmit = async ({ email, password, googleToken }: TLogInFormValues) => {
//     // login api call
//     dispatch(
//       signIn({
//         email,
//         password,
//         googleToken
//       })
//     ).then((response: unknown) => {
//       const loginResponse = response as unknown as APIResponse<TSignInResponse>;
//       const status: number = loginResponse?.status;
//       const isOnboardingComplete: boolean = loginResponse?.data?.data?.user?.onboardingComplete;
//       const user = loginResponse?.data?.data?.user;
//       const userType = loginResponse?.data?.data?.type;
//       const isMentorOrInvestor =
//         user?.role === 'Mentor' ||
//         user?.role === 'Investor' ||
//         user?.role === 'Mentor and Investor';

//       if (status === 200 && userType === 'User') {
//         if (isOnboardingComplete) {
//           navigate(prevRoute || '/dashboard');
//         } else if (isMentorOrInvestor) {
//           navigate('/tell-me-more?userType=MENTOR_INVESTOR');
//         } else {
//           navigate('/onboarding-user-type');
//         }
//       }
//     });
//   };

//   const handleGoogleSubmit = async ({ email, password, googleToken }) => {
//     // login api call
//     dispatch(
//       signIn({
//         email,
//         password,
//         googleToken
//       })
//     ).then((response: unknown) => {
//       const loginResponse = response as unknown as APIResponse<TSignInResponse>;
//       const status: number = loginResponse?.status;
//       const isOnboardingComplete: boolean = loginResponse?.data?.data?.user?.onboardingComplete;
//       const user = loginResponse?.data?.data?.user;
//       const userType = loginResponse?.data?.data?.type;
//       const isMentorOrInvestor =
//         user?.role === 'Mentor' ||
//         user?.role === 'Investor' ||
//         user?.role === 'Mentor and Investor';

//       if (status === 200 && userType === 'User') {
//         if (isOnboardingComplete) {
//           // navigate(prevRoute || '/dashboard');
//           navigate('/dashboard');
//         } else if (isMentorOrInvestor) {
//           navigate('/tell-me-more?userType=MENTOR_INVESTOR');
//         } else {
//           navigate('/onboarding-user-type');
//         }
//       }
//     });
//   };

//   useEffect(() => {
//     if (shouldRedirectToDashboard) {
//       navigate('/dashboard');
//     }
//     return () => {
//       dispatch(resetRedirection());
//     };
//   }, [shouldRedirectToDashboard]);
//   useEffect(() => {
//     if (shouldRedirectToRoleSelection && !shouldRedirectToDashboard) {
//       navigate('/onboarding-user-type');
//     }
//     return () => {
//       dispatch(resetRedirection());
//     };
//   }, [shouldRedirectToRoleSelection, shouldRedirectToDashboard]);

//   useEffect(() => {
//     if (shouldRedirectToForceChangePassword) {
//       navigate('/force-change-password');
//     }
//     return () => {
//       dispatch(resetRedirection());
//     };
//   }, [shouldRedirectToForceChangePassword]);

//   useEffect(() => {
//     if (window.location.hash.includes('access_token')) {
//       dispatch(
//         signIn({
//           email: "null@gmail.com",
//           password: "null",
//           googleToken: window.location.hash
//         })
//       ).then((response: unknown) => {
//         const loginResponse = response as unknown as APIResponse<TSignInResponse>;
//         console.log("login response", loginResponse);
//         const status: number = loginResponse?.status;
//         const isOnboardingComplete: boolean = loginResponse?.data?.data?.user?.onboardingComplete;
//         const user = loginResponse?.data?.data?.user;
//         const userType = loginResponse?.data?.data?.type;
//         const isMentorOrInvestor =
//           user?.role === 'Mentor' ||
//           user?.role === 'Investor' ||
//           user?.role === 'Mentor and Investor';

//         if (status === 200 && userType === 'User') {
//           if (isOnboardingComplete) {
//             navigate('/dashboard');
//           } else if (isMentorOrInvestor) {
//             navigate('/tell-me-more?userType=MENTOR_INVESTOR');
//           } else {
//             navigate('/onboarding-user-type');
//           }
//         }
//       });
//     } else {
//       console.log("null");
//     }
//   }, []);

//   return (
//     <div className="log-in">
//       <BackNavigation text="Back" route={prevRoute || '/'} />
//       <Typography as="h3" variant="heading-3" fontWeight="semiBold" className="log-in__heading">
//         Login
//       </Typography>
//       <Typography as="p" variant="body-2" fontWeight="regular" className="log-in__caption">
//         Welcome Back...
//       </Typography>

//       {/* Form starts */}
//       <Formik
//         initialValues={initialValues}
//         onSubmit={handleSubmit}
//         validationSchema={signInValidationSchema}
//       >
//         {({ errors, touched, setFieldValue, values }) => {
//           return (
//             <Form className="log-in__form" noValidate>
//               {/* NoValidate is used, because yup is used to validate the user input */}
//               <InputField
//                 label="Enter Email Address"
//                 id="email"
//                 variant={componentSizeVariantsEnum.SMALL}
//                 placeholder="Email Address"
//                 startIcon={<MailIcon />}
//                 type="email"
//                 value={values.email}
//                 onChange={(e) => {
//                   setFieldValue('email', e.target.value);
//                 }}
//                 errorMessage={errors.email}
//                 isTouched={touched.email}
//               />
//               <InputField
//                 label="Enter Password"
//                 id="password"
//                 variant={componentSizeVariantsEnum.SMALL}
//                 placeholder="Password"
//                 startIcon={<PasswordIcon />}
//                 endIcon={maskPassword ? <EyeOffIcon /> : <EyeIcon />}
//                 maskField={maskPassword}
//                 endIconClickHandler={() => setMaskPassword((prev) => !prev)}
//                 value={values.password}
//                 onChange={(e) => {
//                   setFieldValue('password', e.target.value);
//                 }}
//                 errorMessage={errors.password}
//                 isTouched={touched.password}
//               />
//               <Link to="/forgot-password" className="log-in__form__forgot-password">
//                 Forgot Password?
//               </Link>
//               <Button variant="primary" size="small" type="submit" loading={loading}>
//                 <Typography as="span" variant="body-2" fontWeight="semiBold">
//                   Continue
//                 </Typography>
//               </Button>
//             </Form>
//           );
//         }}
//       </Formik>

//       {/* Form ends */}

//       <div className="log-in__footer">
//         <Typography as="span" variant="body-2" fontWeight="medium">
//           Don’t have an account?
//         </Typography>
//         {/* <Link to={`/sign-up?prev=${prevRoute || '/login'}`}>Sign Up</Link> */}
//         <Link to={`/sign-up`}>Sign Up</Link>
//       </div>
//       {/* <GoogleLogin
//         onSuccess={credentialResponse => {
//           console.log(credentialResponse)
//           handleGoogleSubmit(({
//             email: "null@gmail.com",
//             password: "null",
//             googleToken: credentialResponse.credential
//           }))
//         }}
//         onError={() => {
//           console.log('Login Failed');
//         }}
//       /> */}
//       <div className="log-in__or-container">
//         <div className="log-in__or-line"></div>
//         <Typography as="span" variant="body-2" fontWeight="medium" className="log-in__or-text">
//           OR
//         </Typography>
//         <div className="log-in__or-line"></div>
//       </div>
//       <div className="google-login-button-container">
//         <GoogleLogin
//           text="continue_with"
//           onSuccess={credentialResponse => {
//             console.log(credentialResponse);
//             handleGoogleSubmit({
//               email: "null@gmail.com",
//               password: "null",
//               googleToken: credentialResponse.credential
//             });
//           }}
//           onError={() => {
//             console.log('Login Failed');
//           }}
//           containerProps={{ className: "google-login-button" }}
//         />
//       </div>
//     </div>
//   );
// };

// export default Login;
// new
import { useEffect, useState } from 'react';
import { Form, Formik } from 'formik';
import { useGoogleLogin } from '@react-oauth/google';
import { Link, useNavigate } from 'react-router-dom';
import BackNavigation from 'src/components/common/backNavigation/BackNavigation';
import Button from 'src/components/button/Button';
import Typography from 'src/components/common/typography/Typography';
import InputField from 'src/components/common/formFields/inputField/InputField';
import { componentSizeVariantsEnum } from 'src/constants/common.constants';
import { EyeIcon, EyeOffIcon, MailIcon, PasswordIcon } from 'src/components/common/common.icons';
import { resetRedirection, signIn } from 'src/store/auth/auth.slice';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import useUrlParamValue from 'src/hooks/useUrlParamValue/useUrlParamValue';
import { TSignInResponse } from 'src/services/apiEndpoint.types.ts';
import { APIResponse } from 'src/services/base.api.service';
import GoogleLogo from 'src/assets/images/AuthLogo/g-logo.png';

import './login.scss';
import signInValidationSchema from './login.validationSchema';

export type TLogInFormValues = {
  email: string;
  password: string;
  googleToken?: string;
  googleCode?: string;
};

const Login = () => {
  const initialValues: TLogInFormValues = {
    email: '',
    password: '',
    googleToken: null,
    googleCode: null
  };

  const [maskPassword, setMaskPassword] = useState<boolean>(true);
  const [googleToken, setGoogleToken] = useState<string | null>(null);

  // Hooks
  const { paramValue } = useUrlParamValue();

  const prevRoute = paramValue({ paramName: 'prev' });
   const vc = paramValue({ paramName: 'partnerInvestor' });
  console.log("investorId", vc);

  const {
    loading,
    shouldRedirectToDashboard,
    shouldRedirectToRoleSelection,
    shouldRedirectToForceChangePassword
  } = useAppSelector((store) => store.auth);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleSubmit = async ({ email, password, googleToken }: TLogInFormValues) => {
    // login api call
    dispatch(
      signIn({
        email,
        password,
        googleToken,
        referrerInvestorId: vc || null
      })
    ).then((response: unknown) => {
      const loginResponse = response as unknown as APIResponse<TSignInResponse>;
      const status: number = loginResponse?.status;
      const isOnboardingComplete: boolean = loginResponse?.data?.data?.user?.onboardingComplete;
      const user = loginResponse?.data?.data?.user;
      const userType = loginResponse?.data?.data?.type;
      const isMentorOrInvestor =
        user?.role === 'Mentor' ||
        user?.role === 'Investor' ||
        user?.role === 'Mentor and Investor';

      if (status === 200 && userType === 'User') {
        if (isMentorOrInvestor && user.isGoUser) {
          navigate('/score')
        } else if (isMentorOrInvestor) {
          navigate('/investor');
        } else if (isOnboardingComplete && user.isGoUser) {
          navigate(prevRoute || '/score');
        } else if (isOnboardingComplete) {
          navigate(prevRoute || '/startup-onboarding');
        } else if (isMentorOrInvestor) {
          // navigate('/tell-me-more?userType=MENTOR_INVESTOR');
          navigate('/scoring');
        } else {
          navigate('/onboarding-user-type');
        }
      }
    });
  };

  // OAuth 2.0 Authorization Code Flow for getting refresh tokens
  const login = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: async (codeResponse) => {
      console.log("Auth code received:", codeResponse.code);
      
      // Send the auth code to your backend
      dispatch(
        signIn({
          email: "null@gmail.com",
          password: "null",
          googleToken: codeResponse.code,
          referrerInvestorId: vc || null
        })
      ).then((response: unknown) => {
        const loginResponse = response as unknown as APIResponse<TSignInResponse>;
        const status: number = loginResponse?.status;
        const isOnboardingComplete: boolean = loginResponse?.data?.data?.user?.onboardingComplete;
        const user = loginResponse?.data?.data?.user;
        const userType = loginResponse?.data?.data?.type;
        const isMentorOrInvestor =
          user?.role === 'Mentor' ||
          user?.role === 'Investor' ||
          user?.role === 'Mentor and Investor';

        if (status === 200 && userType === 'User') {
          if (isOnboardingComplete && user.isGoUser) {
            navigate(prevRoute || '/score');
          } else if (isOnboardingComplete) {
            navigate(prevRoute || '/startup-onboarding');
          } else if (isMentorOrInvestor) {
            navigate('/tell-me-more?userType=MENTOR_INVESTOR');
          } else {
            navigate('/onboarding-user-type');
          }
        }
      });
    },
    onError: (error) => {
      console.log('Login Failed:', error);
    },
    scope: "email profile openid https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile"
  });

  useEffect(() => {
    if (shouldRedirectToDashboard) {
      navigate('/dashboard');
    }
    return () => {
      dispatch(resetRedirection());
    };
  }, [shouldRedirectToDashboard]);
  
  useEffect(() => {
    if (shouldRedirectToRoleSelection && !shouldRedirectToDashboard) {
      navigate('/onboarding-user-type');
    }
    return () => {
      dispatch(resetRedirection());
    };
  }, [shouldRedirectToRoleSelection, shouldRedirectToDashboard]);

  useEffect(() => {
    if (shouldRedirectToForceChangePassword) {
      navigate('/force-change-password');
    }
    return () => {
      dispatch(resetRedirection());
    };
  }, [shouldRedirectToForceChangePassword]);

  useEffect(() => {
    if (window.location.hash.includes('access_token')) {
      dispatch(
        signIn({
          email: "null@gmail.com",
          password: "null",
          googleToken: window.location.hash
        })
      ).then((response: unknown) => {
        const loginResponse = response as unknown as APIResponse<TSignInResponse>;
        console.log("login response", loginResponse);
        const status: number = loginResponse?.status;
        const isOnboardingComplete: boolean = loginResponse?.data?.data?.user?.onboardingComplete;
        const user = loginResponse?.data?.data?.user;
        const userType = loginResponse?.data?.data?.type;
        const isMentorOrInvestor =
          user?.role === 'Mentor' ||
          user?.role === 'Investor' ||
          user?.role === 'Mentor and Investor';

        if (status === 200 && userType === 'User') {
          if (isOnboardingComplete) {
            navigate('/dashboard');
          } else if (isMentorOrInvestor) {
            navigate('/tell-me-more?userType=MENTOR_INVESTOR');
          } else {
            navigate('/onboarding-user-type');
          }
        }
      });
    } else {
      console.log("null");
    }
  }, []);

  return (
    <div className="log-in">
      {/* <BackNavigation text="Back" route={prevRoute || '/'} /> */}
      <Typography as="h3" variant="heading-3" fontWeight="semiBold" className="log-in__heading">
        Login
      </Typography>
      <Typography as="p" variant="body-2" fontWeight="regular" className="log-in__caption">
        Welcome Back...
      </Typography>

      {/* Form starts */}
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={signInValidationSchema}
      >
        {({ errors, touched, setFieldValue, values }) => {
          return (
            <Form className="log-in__form" noValidate>
              {/* NoValidate is used, because yup is used to validate the user input */}
              <InputField
                label="Enter Email Address"
                id="email"
                variant={componentSizeVariantsEnum.SMALL}
                placeholder="Email Address"
                startIcon={<MailIcon />}
                type="email"
                value={values.email}
                onChange={(e) => {
                  setFieldValue('email', e.target.value);
                }}
                errorMessage={errors.email}
                isTouched={touched.email}
              />
              <InputField
                label="Enter Password"
                id="password"
                variant={componentSizeVariantsEnum.SMALL}
                placeholder="Password"
                startIcon={<PasswordIcon />}
                endIcon={maskPassword ? <EyeOffIcon /> : <EyeIcon />}
                maskField={maskPassword}
                endIconClickHandler={() => setMaskPassword((prev) => !prev)}
                value={values.password}
                onChange={(e) => {
                  setFieldValue('password', e.target.value);
                }}
                errorMessage={errors.password}
                isTouched={touched.password}
              />
              <Link to="/forgot-password" className="log-in__form__forgot-password">
                Forgot Password?
              </Link>
              <Button variant="primary" size="small" type="submit" loading={loading}>
                <Typography as="span" variant="body-2" fontWeight="semiBold">
                  Continue
                </Typography>
              </Button>
            </Form>
          );
        }}
      </Formik>

      {/* Form ends */}

      <div className="log-in__footer">
        <Typography as="span" variant="body-2" fontWeight="medium">
          Do not have an account?
        </Typography>
        <Link to={`/sign-up?${vc ? `partnerInvestor=${vc}` : ''}`}>Sign Up</Link>
      </div>
      
      <div className="log-in__or-container">
        <div className="log-in__or-line"></div>
        <Typography as="span" variant="body-2" fontWeight="medium" className="log-in__or-text">
          OR
        </Typography>
        <div className="log-in__or-line"></div>
      </div>
      
      <div className="google-login-button-container">
        <button 
          onClick={() => login()} 
          className="google-login-button custom-google-button"
        >
          <img 
            src={GoogleLogo} 
            alt="Google logo" 
            className="google-icon" 
          />
          <Typography as="span" variant="body-2" fontWeight="semiBold">
            Continue with Google
          </Typography>
        </button>
      </div>
    </div>
  );
};

export default Login;
